import type { FC } from 'react'

export const PageHeadSecondaryAssets: FC = () => {
	return (
		<div className="w-full pointer-events-none" aria-hidden="true">
			{/* Mobile Assets */}
			<div className="flex w-full flex-col justify-between tablet-p:hidden overflow-hidden">
				<svg
					viewBox="0 0 155 128"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="absolute -top-px right-0 w-38.75 h-auto self-end -mt-px"
				>
					<path
						d="M155.001 128.007L45.7344 18.7441C33.7321 6.74241 17.4538 2.22176e-05 0.480469 0H155.001V128.007Z"
						fill="white"
					/>
					<path
						d="M155 104L78.3137 27.3137C68.2343 17.2343 75.3729 0 89.6274 0H155V104Z"
						fill="#005EB8"
					/>
				</svg>
				<svg
					className="absolute -bottom-px left-0 w-15.5 h-auto self-start"
					viewBox="0 0 63 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 0.988281L17.2666 18.2549C29.2688 30.2566 45.5472 36.9989 62.5205 36.999H0V0.988281Z"
						fill="white"
					/>
				</svg>
			</div>
			{/* Tablet and desktop Assets */}
			<div className="relative w-full flex-col justify-between hidden tablet-p:flex">
				<svg
					viewBox="0 0 536 366"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="w-107 h-auto self-end -mt-px desktop:w-134"
				>
					<path
						d="M536.129 366H341.857C370.369 366 384.645 331.526 364.48 311.369L90.4941 37.4746C66.4908 13.4796 33.94 0 0 0H536.129V366Z"
						fill="white"
					/>
					<path
						d="M536.129 366H503.261C469.321 366 436.77 352.521 412.767 328.525L138.78 54.6309C118.617 34.4736 132.892 0.000390666 161.403 0H536.129V366Z"
						fill="#005EB8"
					/>
				</svg>
				<svg
					viewBox="0 0 126 73"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="absolute -bottom-px left-0 w-23.5 h-auto self-start desktop:w-31.5"
				>
					<path
						d="M0 0.976562L34.5332 35.5088C58.5378 59.5127 91.0949 72.998 125.042 72.998H0V0.976562Z"
						fill="white"
					/>
				</svg>
			</div>
		</div>
	)
}

export default PageHeadSecondaryAssets
